/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'

// Images
import LazarusLogo from '../images/LazarusLogo.svg'

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesTopRow from '../styles/TopRow.module.css'

// Actions
import {signOut} from '../actions/signOut'

// Components
import ManageTools from './ManageTools'
// import ManageFiles from './ManageFiles'
import {Avatar} from '@lazarusai/forms-ui-components'

function TopRow(props) {
  return (
    <div
      className={stylesTopRow['top-row']}
    >
      <div
        className={`${stylesTopRow['top-row-side']} ${stylesTopRow['top-row-left']}`}
      >
        <img
          src={LazarusLogo}
        />
      </div>
      <div
        className={`${stylesTopRow['top-row-side']} ${stylesTopRow['top-row-right']}`}
      >
        <Avatar
          name={props.user?.displayName ? props.user?.displayName : props.user?.email}
          size='large'
          showGradient
          onClick={props.signOut}
        />
        {/* <ManageFiles /> */}
        <ManageTools />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {signOut},
)(TopRow)
